
export module Validator {

    export function validateInn(value: string | undefined): string | undefined {
        if (!value) {
            return 'Заполните ИНН'
        }
        value = value.trim()
        if (/^\d{10}$|^\d{12}$/.test(value)) {
            // ok
        } else {
            return 'Убедитесь что ИНН введен корректно'
        }

        return undefined
    }

    /**
     * 
     * @param email 
     * @returns 
     */
    export function validateEmail(p:{text: string|null|undefined, allowEmpy: boolean}) {
        if(!p.text){
            if(!p.allowEmpy){
                return 'Введите email'
            }
        } else {
            // https://stackoverflow.com/questions/46155/how-to-validate-an-email-address-in-javascript
            const re = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
            const isValid = re.test(String(p.text).toLowerCase());
            if (!isValid) {
                return 'Убедитесь что email введен корректно'
            }
        }
        return undefined
    }

    export function validatePhone(p: { text: string | null | undefined, allowEmpy: boolean }) {
        if (!p.text) {
            if (!p.allowEmpy) {
                return 'Введите телефон'
            }
        } else {
            const digitsOnly = p.text.replace(/\D/g, '');
            if (digitsOnly.length !== 11) {
                return 'Убедитесь что телефон введен корректно'
            }
        }
        return undefined
    }

}